<template>
  <div class="">
    <iframe
      :src="url"
      frameborder="0"
      style="height: 100vh; width: 100%"
    ></iframe>
  </div>
</template>

<script>
import { setOpenId, getOpenId } from "@/utils/auth";
import config from "@/config/index";
export default {
  props: {},
  data() {
    return {
      url: "",
    };
  },
  created() {
    // this.MemberInfo()
    this.gotoUrlIntrgral();
  },
  methods: {
    gotoUrlIntrgral() {
      this.url =
        "https://workflow.anluoyun.cn/#/?integral=" +
        this.$route.params.totalIntegral +
        "&platformId=" +
        config.platformId +
        "&url=" +
        config.hostUrl +
        "&openId=" +
        getOpenId() +
        "&storeId=null";
      // window.open(this.url, '_blank')
      // window.location.href = url
    },
  },
};
</script>
